import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { formatText } from 'src/app/shared/commen-function-file';
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}
@Component({
  selector: 'app-reusable-table',
  templateUrl: './reusable-table.component.html',
  styleUrls: ['./reusable-table.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class ReusableTableComponent  implements OnInit {
  @Input() parentHeaders: { key: string, label: string }[] = [];
  @Input() nestedHeaders: { key: string, label: string }[] = [];
  @Input() tableData: any[] = [];
  @Input() nestedKey: string = 'details'; // Key for nested data
  @Input() expandKey: string = 'isExpand'; // Key for expand status
  @Input() selectedTabName: string='';
  formatedataVariable = formatText;
  @Output() onAssetNameClick = new EventEmitter<any>();
  @Output() onAssetNameClickInside = new EventEmitter<any>();
  @Output() deleteEmployee = new EventEmitter<any>();
  hideDate: boolean = true; // Set to false to show the value
constructor(private datePipe: DatePipe){}
  ngOnInit() {
    
    this.tableData = this.tableData.map((elm: any) => {
      return {
        ...elm,
        users: elm.users.map((record: any) => {
          return {
            ...record,
            dateOfAllocation: this.datePipe.transform(record.dateOfAllocation, 'dd/M/yyyy'),
            authorityCommentDate: this.datePipe.transform(record.authorityCommentDate, 'dd/M/yyyy'),
            employeeCommentDate: this.datePipe.transform(record.employeeCommentDate, 'dd/M/yyyy'),
            employeeAssetStatus: this.formatedataVariable(record.employeeAssetStatus),
            authorityDepartmentComment: this.formatedataVariable(record.authorityDepartmentComment)
          };
        })
      };
    });
    
    console.log(this.tableData);
    
  }


  emitAssetName(assetName: any) {
    console.log(assetName);
    
    this.onAssetNameClick.emit(assetName);
   
  }
  emitAssetNameinside(assetName: any) {
    console.log(assetName,".........");
    
    this.onAssetNameClickInside.emit(assetName);
   
  }
  deleteData(id:any){
    this.deleteEmployee.emit(id);
  }
  // Method to check if the row should expand and has valid users
shouldExpand(row: any): boolean {
  return row[this.expandKey] && row.users && row.users.some((user:any) => user.userId !== null);
}

getColspan(): number {
  return this.parentHeaders.length + 1;
}

// Define the callback actions
tableActions = [
  {
    label: 'Edit',
    callback: (row: any) => {
      console.log('Edit clicked for:', row);
      // Handle edit logic here
    }
  },
  {
    label: 'Delete',
    callback: (row: any) => {
      console.log('Delete clicked for:', row);
      // Handle delete logic here
    }
  }
];

}
